import { FirstContenxt } from "./firstContent";

export const Main = () => {
    return (<div>
        <FirstContenxt />

    </div>);
}